import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../environment/environment';

interface BadgeConfig {
  label: string;
  cssClass: string;
}

// `prod` is intentionally absent - no badge is shown in production
const BADGE_CONFIG: Record<string, BadgeConfig | undefined> = {
  local: { label: 'Local', cssClass: 'local' },
  dev: { label: 'Dev', cssClass: 'dev' },
  test: { label: 'Test', cssClass: 'test' },
  feature: { label: 'Feature', cssClass: 'feature' },
  hotfix: { label: 'Hotfix', cssClass: 'hotfix' },
};

@Component({
  selector: 'smata-environment-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './environment-badge.component.html',
  styleUrl: './environment-badge.component.scss',
})
export class EnvironmentBadgeComponent {
  readonly config = BADGE_CONFIG[environment.envName];
}
